var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompactLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87507 0.00510398C11.5246 -0.038081 13.1698 0.193032 14.7412 0.688707C15.9071 1.06478 16.9702 1.69852 17.8491 2.54145C18.6097 3.29717 19.1768 4.2202 19.5036 5.23432C19.8364 6.2673 20.0038 7.345 19.9999 8.4287C20.0023 9.52891 19.817 10.6217 19.4517 11.6614C19.0885 12.6922 18.4954 13.6298 17.7161 14.4054C16.8338 15.26 15.767 15.9075 14.5952 16.2997C13.0778 16.7984 11.484 17.034 9.8848 16.996H0V0.00510398H9.87507ZM3.54906 14.0125H9.79397C10.876 14.0429 11.9552 13.8872 12.9829 13.5525C13.7455 13.2993 14.436 12.8712 14.9975 12.3035C15.487 11.7963 15.8521 11.1855 16.0648 10.5178C16.2809 9.84628 16.3903 9.14591 16.3892 8.44147C16.3918 7.74529 16.2823 7.05312 16.0648 6.39069C15.8511 5.73853 15.4857 5.14455 14.9975 4.65613C14.4304 4.10501 13.7406 3.69158 12.9829 3.44865C11.9532 3.12348 10.875 2.97227 9.79397 3.00144H3.54906V14.0125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactLogo);
export default __webpack_public_path__ + "static/media/compactLogo.d307e5d01fa56c9cdf44f705f134f6f4.svg";
export { ForwardRef as ReactComponent };